<template>
  <div class="recommend">
    <h3>热门课程推荐</h3>
    <div class="more">
      <RouterLink
        target="_blank"
        :to="`/video?firstCate=${list[0]?.chID}&secondCate=${list[0]?.coID}&thirdCate=${list[0]?.clID}`"
      >
        <span>更多</span>
        <el-icon><ArrowRight /></el-icon>
      </RouterLink>
    </div>
  </div>
  <Transition name="fade">
    <div v-if="list.length" class="recommend-cate">
      <div class="cate-left" v-for="item in list" :key="item.index">
        <RouterLink
          target="_blank"
          :to="`/video/videodetail?clID=${item.clID}&id=${item.id}`"
        >
          <i>网课</i>
          <img v-lazy="item.coverImg" alt="" />
          <p class="grade" v-if="item.grade.grName.length <= 4">
            {{ item.grade.grName }}
          </p>
          <p class="grade1" v-if="item.grade.grName.length > 4">
            {{ item.grade.grName }}
          </p>
          <el-text line-clamp="2">
            {{ item.leName }}
          </el-text>
        </RouterLink>
        <div class="cate-desc">
          <h3>&yen;{{ item.grade.salePrice }}</h3>
          <RouterLink
            target="_blank"
            :to="`/video/videodetail?clID=${item.clID}&id=${item.id}`"
          >
            <el-button size="small">查看详情</el-button>
          </RouterLink>
        </div>
      </div>
    </div>
    <NewsSkeleton v-else />
  </Transition>
</template>

<script>
import NewsSkeleton from "../common/news-skeleton.vue";
export default {
  components: {
    NewsSkeleton,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>

.recommend {
  display: flex;
  height: 50px;
  width: 400px;
  align-items: center;
  justify-content: space-between;
  background: rgb(244, 244, 244);
  h3 {
    margin-left: 10px;
  }
  .more {
    a {
      display: flex;
      align-items: center;
      margin-right: 10px;
      color: #999;
      &:hover {
        color: @shColor;
      }
    }
  }
}
.recommend-cate {
  display: flex;
  height: 210px;
  width: 400px;
  justify-content: space-between;
  .cate-left {
    width: 195px;
    height: 210px;
    position: relative;
    border: 1px solid rgb(244, 244, 244);
    a {
      position: relative;
      width: 195px;
      margin-right: 5px;

      img {
        width: 195px;
        height: 120px;
      }
      .grade {
        position: absolute;
        font-weight: bold;
        top: 32%;
        left: 36.5%;
      }
      .grade1 {
        position: absolute;
        font-weight: bold;
        top: 32%;
        left: 31.5%;
      }
      i {
        display: inline-block;
        position: absolute;
        top: -49px;
        right: 0;
        width: 30px;
        height: 15px;
        text-align: center;
        line-height: 15px;
        color: #fff;
        font-size: 12px;
        background: @shColor;
        border-radius: 2px;
      }
      span {
        margin: 5px 5px 5px 5px;
        &:hover {
          color: @shColor;
        }
      }
    }
    .cate-desc {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      h3 {
        width: 80px;
        margin-left: 10px;
        color: #fd7502;
      }
      a {
        display: inline-block;
        height: 22px;
        margin-bottom: 5px;
        width: 80px;
      }
    }
  }
}
</style>
